import React from "react";

import {
  Button,
  IconButton,
  Paper,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import { useTranslations } from "hooks/useTranslations";
import Close from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const { translations } = useTranslations();
  const responseTranslations = translations.customResponseCodes;

  const navigate = useNavigate();

  const routeHome = () => {
    navigate("/");
  };

  const {
    root,
    alertWrapper,
    closeIcon,
    headerText,
    subtitleText,
    bodyText,
    backgroundText,
  } = sxStyles;

  return (
    <Paper sx={root}>
      <Stack sx={alertWrapper} alignItems="start" justifyContent="center">
        <IconButton
          sx={{ ...closeIcon, color: "white.main" }}
          onClick={routeHome}
        >
          <Close />
        </IconButton>
        <Typography variant="h1" sx={headerText} textTransform="uppercase">
          {responseTranslations.pageNotFound.title}
        </Typography>
        <Typography variant="h4" sx={subtitleText}>
          {responseTranslations.pageNotFound.subtitle}
        </Typography>
        <Typography variant="bodyMedium" sx={bodyText}>
          {responseTranslations.pageNotFound.text}
        </Typography>
        <Button variant="outlined" color="white" onClick={routeHome}>
          {responseTranslations.pageNotFound.CTA}
        </Button>
      </Stack>
      <Typography variant="h2" sx={backgroundText}>
        404
      </Typography>
    </Paper>
  );
};

export default PageNotFound;

const sxStyles: { [key: string]: SxProps } = {
  root: {
    backgroundColor: "primary.main",
    minHeight: "100vh",
    position: "relative",
    overflow: "hidden",
  },
  alertWrapper: {
    p: {
      xs: 4,
      sm: 6,
      xl: 18,
    },
    width: "100vw",
    maxWidth: {
      xs: "520px",
      sm: "560px",
      md: "660px",
      lg: "760px",
      xl: "1000px",
    },
    minHeight: "100vh",
    "& *": {
      zIndex: 1,
    },
  },
  closeIcon: {
    transform: "translateX(-50%)",
  },
  headerText: {
    lineHeight: 1.2,
    mb: 2,
    color: "white.main",
  },
  subtitleText: { lineHeight: 1.2, mb: 1, color: "white.main" },
  bodyText: { lineHeight: 1.2, mb: 2, color: "white.main" },
  backgroundText: {
    right: "-8%",
    bottom: "-7%",
    position: "absolute",
    color: "primary.main",
    textShadow:
      "-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff",
    lineHeight: 1,
    zIndex: 0,
    fontSize: {
      sx: "270px",
      sm: "350px",
      md: "530px",
      lg: "580px",
      xl: "650px",
    },
  },
};
